<template>
	<section class="download-section" :aria-label="t(`${I18N_NS}.download.ariaLabel`)">
		<div class="download-section__bg" aria-hidden="true"></div>
		<div class="download-section__inner pc-center-1200">
			<div class="download-section__content">
				<h2 class="download-section__title">{{ t(`${I18N_NS}.download.title`) }}</h2>
				<p class="download-section__desc">{{ t(`${I18N_NS}.download.desc`) }}</p>
			</div>

			<div class="download-section__actions">
				<a
					href="javascript:void(0)"
					class="download-section__button"
					:aria-label="t(`${I18N_NS}.download.googlePlayAria`)"
					@click="emit('android-click')"
				>
					<img class="download-section__button-icon" src="./images/google-play.png" alt="" />
					<span class="download-section__button-text">
						<span class="download-section__button-label">{{
							t(`${I18N_NS}.download.storeLabel`)
						}}</span>
						<span class="download-section__button-name">{{
							t(`${I18N_NS}.download.googlePlayName`)
						}}</span>
					</span>
				</a>
				<a
					href="javascript:void(0)"
					class="download-section__button"
					:aria-label="t(`${I18N_NS}.download.appStoreAria`)"
					@click="emit('ios-click')"
				>
					<img class="download-section__button-icon" src="./images/app-store.png" alt="" />
					<span class="download-section__button-text">
						<span class="download-section__button-label">{{
							t(`${I18N_NS}.download.storeLabel`)
						}}</span>
						<span class="download-section__button-name">{{
							t(`${I18N_NS}.download.appStoreName`)
						}}</span>
					</span>
				</a>
				<a
					:href="apkLink"
					download
					class="download-section__button"
					:aria-label="t(`${I18N_NS}.download.apkAria`)"
					@click="emit('direct-download')"
				>
					<img class="download-section__button-icon" src="./images/android.png" alt="" />
					<span class="download-section__button-text">
						<span class="download-section__button-label">{{
							t(`${I18N_NS}.download.apkLabel`)
						}}</span>
						<span class="download-section__button-name">{{
							t(`${I18N_NS}.download.apkName`)
						}}</span>
					</span>
				</a>
			</div>
		</div>
	</section>
</template>

<script setup>
import { useI18n } from "~/composables/useI18n";

const I18N_NS = "aboutUs";
const { t } = useI18n();

defineProps({
	apkLink: {
		type: String,
		default: "",
	},
});

const emit = defineEmits(["android-click", "ios-click", "direct-download"]);
</script>

<style lang="scss" scoped>
.download-section {
	position: relative;
	box-sizing: border-box;
	width: 100%;
	max-width: 100%;
	overflow: hidden;

	&__bg {
		position: absolute;
		inset: 0;
		width: 100%;
		background: linear-gradient(90deg, #fffcf6 0%, #fff1cb 91.34%);
		z-index: 0;
	}

	&__inner {
		position: relative;
		z-index: 1;
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
		justify-content: space-between;
		gap: 24px;
		padding: 36px 64px;
	}

	&__content {
		flex: 1 1 auto;
		min-width: 0;
	}

	&__title {
		margin: 0 0 8px;
		color: #333333;
		font-size: 28px;
		font-weight: 700;
		line-height: 1.4;
	}

	&__desc {
		margin: 0;
		color: rgba(51, 51, 51, 0.45);
		font-size: 24px;
		line-height: 1.4;
	}

	&__actions {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		flex: 0 1 auto;
		gap: 18px;
	}

	&__button {
		display: inline-flex;
		align-items: center;
		gap: 10px;
		flex: 0 0 auto;
		min-width: 180px;
		padding: 16px;
		border-radius: 10px;
		background: #333333;
		color: #ffffff;
		text-decoration: none;
		transition: opacity 0.2s ease;
		box-sizing: border-box;

		&:hover {
			opacity: 0.7;
		}
	}

	&__button-icon {
		width: 39px;
		height: 39px;
		flex-shrink: 0;
		object-fit: contain;
	}

	&__button-text {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		line-height: 1.2;
	}

	&__button-label {
		font-size: 14px;
		font-weight: 400;
		line-height: 24px;
	}

	&__button-name {
		font-size: 18px;
		font-weight: 600;
	}
}

/* 中等宽度：保持左右布局，按钮区自适应换行 */
@media (max-width: 1100px) {
	.download-section {
		&__inner {
			flex-wrap: wrap;
			padding: 32px 24px;
		}

		&__actions {
			justify-content: flex-start;
			width: auto;
			max-width: 100%;
		}

		&__button {
			flex: 1 1 calc(50% - 9px);
			max-width: calc(50% - 9px);
			min-width: 0;
		}
	}
}

@media (max-width: 1024px) {
	.download-section {
		&__title {
			font-size: 24px;
		}

		&__desc {
			font-size: 20px;
		}
	}
}

/* 小屏：上下布局，按钮一�?2 �?*/
@media (max-width: 768px) {
	.download-section {
		&__inner {
			flex-direction: column;
			align-items: flex-start;
		}

		&__actions {
			width: 100%;
		}

		&__title {
			font-size: 24px;
		}

		&__desc {
			font-size: 18px;
		}
	}
}
</style>
